import React, { useState } from "react";
import QRGenerateButton from "./QRGenerateButton";

function TextQR() {
  const [input, setInput] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [formError, setFormError] = useState(false);

  function showQRCode() {
    document.getElementById("qrwrap").scrollIntoView({
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="qr-form">
        <h3>Text QR Code</h3>
        <p>Send any text as a QR, the potential is unlimited.</p>
        <textarea
          onInput={(e) => setInput(e.target.value)}
          name="qrcode_texts"
          id="qr_texts"
          placeholder="Enter your text"
          value={input}
        />
        {formError && (
          <div className="errorMessage">Error: Field cannot be blank!</div>
        )}
        <button
          type="button"
          className="contrast"
          onClick={() => {
            if (input !== "") {
              setShowQR(true);
              showQRCode();
              setFormError(false);
            } else {
              setShowQR(false);

              setFormError(true);
            }
          }}
        >
          Generate QR
        </button>
      </div>
      <QRGenerateButton
        QRType="texts"
        QRValue={input}
        showQR={showQR}
        setInput={setInput}
        setShowQR={setShowQR}
      />
    </>
  );
}

export default TextQR;
